import api from "./axios";
import type { Event } from "@/types";

export const getAll = () => api.get<Event[]>("/events").then((r) => r.data);

export const getById = (id: string) =>
  api.get<Event>(`/events/${id}`).then((r) => r.data);

export const create = (data: {
  name: string;
  restaurantId?: string;
  startedAt: string;
  endedAt?: string;
  userIds?: string[];
}) => api.post<Event>("/events", data).then((r) => r.data);

export const update = (
  id: string,
  data: {
    name?: string;
    restaurantId?: string;
    startedAt?: string;
    endedAt?: string;
    userIds?: string[];
  },
) => api.patch<Event>(`/events/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/events/${id}`).then((r) => r.data);

export const addParticipant = (eventId: string, userId: string) =>
  api.post(`/events/${eventId}/participants`, { userId }).then((r) => r.data);

export const removeParticipant = (eventId: string, userId: string) =>
  api.delete(`/events/${eventId}/participants/${userId}`).then((r) => r.data);
